export default __webpack_public_path__ + "static/media/VIN.07b90cd4.svg";